import QuizStatuses from '@/constant/QuizStatuses'

const isLastSlide = (state) => {
  const { slides } = state.presentation
  const lastSlide = slides.length ? slides[slides.length - 1] : null
  return state.slideActive.id && lastSlide && lastSlide.id === state.slideActive.id
}

const isStartPresentingFromLastSlide = (state) => {
  const { slides } = state.presentation
  const lastSlide = slides.length ? slides[slides.length - 1] : null
  return state.startPresentingFromSlideId === lastSlide.id
}

const getSlideActive = (state) => {
  return state.slideActive
}

const isLobbyScreen = (state) => {
  return state.slideActive.quizStatus == QuizStatuses.LOBBY_SCREEN
}

const questionHasImageXLarge = (state) => {
  return !!(state.slideActive.image && state.slideActive.image.xLarge)
}

const isTextColourLight = (state) => {
  return state.slideActive.textColour === '#ffffff'
}

const isQuestionImageEnabled = (state) => {
  return state.slideActive.type === 'pickAnswer' && (
    state.slideActive.slideType === 'typeAnswer' || !state.slideActive.slideType)
}

const isQuestionImageAndHasImageXLargeEnabled = (state) => {
  return questionHasImageXLarge(state) && isQuestionImageEnabled(state)
}

const isShowFullImageQuestion = (state) => {
  return state.slideActive.showFullImageQuestion && questionHasImageXLarge(state)
}

export default {
  isLastSlide,
  getSlideActive,
  isStartPresentingFromLastSlide,
  isLobbyScreen,
  questionHasImageXLarge,
  isTextColourLight,
  isQuestionImageEnabled,
  isShowFullImageQuestion,
  isQuestionImageAndHasImageXLargeEnabled,
}
